import React from 'react';
import './Sections.scss';

function Section3() {
  return (
    <section className="sections sections-marginBox">
      <h2 className="sections-title">Stepping off the escalator of rising rents</h2>
      <p className="sections-copy">
        NAR survey data shows that almost all (93%) of 2022 home buyers have been getting fixed-rate
        mortgages where the required monthly payment stays the same for the life of the loan.
      </p>
      <p className="sections-copy">
        That’s a big difference from the years leading up to the 2008 collapse of the housing
        bubble. “Back then, subprime and other risky variable interest rate mortgages were
        prevalent. They accounted for around 40% of all loans at that time,” explains Yun. “Today,
        we have very few subprime and risky mortgages, in part because lenders have much stricter
        standards for making sure that people only qualify for loans that they can afford. As a
        result, the current housing market today has a solid economic foundation.”
      </p>
      <p className="sections-copy">
        A home buyer who obtained a 30-year fixed-rate mortgage today and lived in that home for
        three decades would still have the same monthly mortgage payment in 2052. By contrast,
        renters generally face the specter of having their monthly rent rise steadily—and sometimes
        dramatically—from one year to the next.
      </p>
      <p className="sections-copy">
        And while a renter’s entire payment goes to the landlord, homeowners get to reduce their
        loan balance with a portion of each mortgage payment they make. This means that each payment
        takes them a little bit closer to paying off the mortgage entirely and owning their home
        free and clear.
      </p>
    </section>
  );
}

export default Section3;
